import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import FeaturesSection from '../../components/FeaturesSection/FeaturesSection';

const About = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-[#fafafd]">
      <Header />
      {/* Hero Section */}
      <section className="bg-white py-16">
        <div className="container mx-auto px-4 max-w-6xl">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-600 mb-6 text-center">
            About <span className="text-4xl md:text-5xl font-bold text-pl_prim_color_1 mb-6 ">Paralegal.lk</span>
          </h1>
          <p className="text-lg text-gray-600 text-center max-w-3xl mx-auto">
            Your trusted partner in AI-powered legal document translation in Sri Lanka.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-pl_prim_color_1 mb-6">
                Our Mission
              </h2>
              <p className="text-gray-600 mb-4">
                At Paralegal.lk, our mission is to make legal document translation faster, more affordable, and accessible. We leverage a specialized AI, trained on legal terminology, to provide instant translations, breaking down language barriers in the Sri Lankan legal landscape.
              </p>
              <p className="text-gray-600">
                We are committed to transparency and efficiency, empowering you to handle your legal translation needs with confidence and control.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md">
              <h3 className="text-2xl font-semibold text-pl_prim_color_1 mb-4">
                Why Choose Us?
              </h3>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <span className="text-pl_prim_color_1 mr-2">✓</span>
                  <span><strong>AI-Powered Precision:</strong> Our AI is specifically trained for legal documents, offering superior accuracy for legal terminology compared to general-purpose translators.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pl_prim_color_1 mr-2">✓</span>
                  <span><strong>Instant Translations:</strong> Get your documents translated in minutes, not days.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pl_prim_color_1 mr-2">✓</span>
                  <span><strong>Transparent Pricing:</strong> Pay-as-you-go at a clear per-word rate. No subscriptions, no hidden fees.</span>
                </li>
                <li className="flex items-start">
                  <span className="text-pl_prim_color_1 mr-2">✓</span>
                  <span><strong>Secure and Confidential:</strong> We prioritize your privacy with secure handling of all documents.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Core Features Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-7xl">
          <h2 className="text-3xl font-bold text-pl_prim_color_1 mb-12 text-center">Core Features</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-semibold mb-4">
                AI Legal Translation
              </h3>
              <p className="text-gray-600">
                Pay-as-you-go service for translating legal documents using our specialized AI.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-semibold mb-4">
                Multiple File Formats
              </h3>
              <p className="text-gray-600">
                We support a wide range of document types, including PDF, DOCX, DOC, JPG, and PNG.
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-semibold mb-4">
                Instant Cost Estimates
              </h3>
              <p className="text-gray-600">
                Upload your document to get an immediate word count and cost estimate before you commit.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Disclaimer Section */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl text-center bg-yellow-50 border border-yellow-200 p-8 rounded-lg">
          <h2 className="text-2xl font-bold text-yellow-700 mb-4">A Note on Accuracy</h2>
          <p className="text-yellow-800">
            While our AI is highly specialized for legal text, it is not a substitute for a human lawyer or certified translator. AI translations may contain inaccuracies. You are solely responsible for reviewing the final translation to ensure it meets your needs. We do not offer refunds for minor translation errors.
          </p>
        </div>
      </section>


      {/* Contact CTA Section */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-7xl text-center">
          <h2 className="text-3xl font-bold text-pl_prim_color_1 mb-6">Ready to Get Started?</h2>
          <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
            Upload your document now and get an instant translation. It&apos;s fast, secure, and easy to use.
          </p>
          <button onClick={handleGetStarted} className="bg-pl_prim_color_1 text-white px-8 py-3 rounded-full hover:bg-pl_prim_color_2 transition-colors font-semibold">
            Translate Now
          </button>
        </div>
        <div className="hidden md:block flex-grow-1 w-full">
                  <FeaturesSection />
                </div>
      </section>

      <Footer/>
    </div>
  );
};

export default About;
